import StyledButton from "components/shared/StyledButton";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import StatusChip from "../../../shared/StatusChip";
import { BeneficiaryPickerFilter } from "../../BeneficiaryPickerFilter/BeneficiaryPickerFilter";

type TProps = {
    handleDownload: (beneficiaryIds: number[]) => void;
    initialBeneficiaryIds?: number[];
    dateRange: string;
};

export const TaxDeclarationExport = ({ handleDownload, initialBeneficiaryIds, dateRange }: TProps) => {
    const [t] = useTranslation();
    const [pickedBeneficiaryIds, setPickedBeneficiaryIds] = useState<number[]>(initialBeneficiaryIds ?? []);

    return (
        <div className="flex flex-col gap-4">
            <span style={{ fontSize: "0.9rem" }}>
                <Trans
                    i18nKey="Payment.TaxDeclarationExport.Text"
                    values={{ dates: dateRange }}
                    components={{
                        status: (
                            <StatusChip
                                status={0}
                                statusRules={{ 0: { color: "green", text: t("Filters.Paid") } }}
                                style={{ marginInline: "5px", height: "fit-content", display: "inline-block" }}
                            />
                        ),
                    }}
                ></Trans>
            </span>
            <div className="flex flex-col gap-1 [&_.MuiAutocomplete-root]:grow overflow-x-auto overflow-y-hidden">
                <BeneficiaryPickerFilter value={pickedBeneficiaryIds} onChange={setPickedBeneficiaryIds} />
            </div>
            <StyledButton buttonType="primary" fullWidth onClick={() => handleDownload(pickedBeneficiaryIds)}>
                {t("Management.YesDownload")}
            </StyledButton>
        </div>
    );
};
